
import "../../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_130_0_SelectableAccordionItem";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_130_0_SelectableAccordionItem__root","item":"wds_1_130_0_SelectableAccordionItem__item","selector":"wds_1_130_0_SelectableAccordionItem__selector","header":"wds_1_130_0_SelectableAccordionItem__header","divider":"wds_1_130_0_SelectableAccordionItem__divider","selectorToggle":"wds_1_130_0_SelectableAccordionItem__selectorToggle","content":"wds_1_130_0_SelectableAccordionItem__content","text":"wds_1_130_0_SelectableAccordionItem__text","inner":"wds_1_130_0_SelectableAccordionItem__inner"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"tinyVerticalPadding":"12px","smallVerticalPadding":"15px","newMediumVerticalPadding":"18px","mediumVerticalPadding":"24px"}; 
export var vars = {}; 




